/*
'use strict';

angular.module('amexReconciliationApp')
    .service('MerchantDropDownModel', function MerchantDropDownModel($rootScope, ModelFactory,UserModel,UserPreferencesRepository) {

        var model = ModelFactory.create('MerchantDropDownModel', ['MerchantField']);
        model.selectedMerchantField = 'MerchantNameTwo';

        var merchantColumns = ['MerchantNameOne','MerchantNameTwo'];

        var  userPreferences;
        model.getFieldValue = function (transaction) {
            if(model.selectedMerchantField === 'MerchantNameOne'){
                return _.get(transaction,'merchantName', '');
            }

            if(model.selectedMerchantField === 'MerchantNameTwo'){
                return _.get(transaction,'merchantName2', '');
            }
        };

        function updateSelectedField() {
            userPreferences = UserModel.currentUserPreferences();
            if (userPreferences.transactionColumnPreferences != null && userPreferences.transactionColumnPreferences.merchantColumn != null) {
                model.selectedMerchantField = userPreferences.transactionColumnPreferences.merchantColumn;
            }
        }

       UserModel.onCurrentUserChanged($rootScope, updateSelectedField);
        return model;
    });

*/



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/models/MerchantDropDownModel.js
// module id = 581
// module chunks = 0